// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
const {
  userProfileFollowersHref,
  userProfileFollowingHref
} = require('client-v2/common/models/user/actions')
// Entry container imports
const ProfileUserRecord = require('../profile-user/record')
const ProfileUserStatsRecord = require('../profile-user-stats/record')

const bem = BemEntity('UserProfileSocialNav')

function UserProfileSocialNavItem(props) {
  return tag('a', {
    className: bem.element('href', {
      selected: props.selected
    }),
    href: props.disabled ? null : props.href,
    onClick: props.disabled ? null : props.onClick
  },
    `${props.label} • ${formatCount(props.count)}`
  )
}

class UserProfileSocialNav extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
  }

  render() {
    const { isSelfProfile, selected, profileUser } = this.props
    const { followers, friends } = this.props.profileUserStats
    return tag('div', {
      className: bem.block()
    },
      tag(UserProfileSocialNavItem, {
        count: followers,
        disabled: !isSelfProfile && !followers,
        href: userProfileFollowersHref(profileUser),
        label: 'Followers',
        selected: selected === 'followers',
        onClick: this.onFollowersClick
      }),
      tag(UserProfileSocialNavItem, {
        count: friends,
        disabled: !isSelfProfile && !friends,
        href: userProfileFollowingHref(profileUser),
        label: 'Following',
        selected: selected === 'following',
        onClick: this.onFollowingClick
      })
    )
  }

}

UserProfileSocialNav.propTypes = {
  // Flags
  isSelfProfile: PropTypes.bool,
  // Values
  profileUser: PropTypes.shape(ProfileUserRecord.propTypes).isRequired,
  profileUserStats: PropTypes.shape(ProfileUserStatsRecord.propTypes).isRequired,
  selected: PropTypes.oneOf(['followers', 'following']).isRequired
}

// Callbacks
UserProfileSocialNav.eventHandlerKeys = [
  'onFollowersClick',
  'onFollowingClick'
]
UserProfileSocialNav.eventHandlerKeys.forEach(key => {
  UserProfileSocialNav.propTypes[key] = PropTypes.func
})

module.exports = UserProfileSocialNav
